import React from 'react'

import { withRouter } from 'react-router-dom'
import { AuthContext } from '../../main/ProvedorAutenticacao'

import ArquivoPessoaService from '../../app/service/ArquivoPessoaService'

class TesteArquivo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fileName: '',
      fileData: null,
      pessoa: ''
    };

    this.arquivoPessoaService = new ArquivoPessoaService();
  }

  handleFetchFile = async () => {
    this.arquivoPessoaService.exibirArquivo(this.state.fileName,23398)
      .then(response => {
        const url = URL.createObjectURL(response.data); // Cria uma URL local para o arquivo
        this.setState({fileData: url});
      }).catch(error => {
        console.error("Erro ao buscar o arquivo", error);
      });
  }  

  render() {
    return(
      <div style={{ padding: "20px" }}>
            <h1>Exibição de Arquivos (com Axios)</h1>
            <input
                type="text"
                placeholder="Digite o nome do arquivo"
                value={this.state.fileName}
                onChange={e => this.setState({fileName: e.target.value})}
                style={{ padding: "10px", marginBottom: "10px" }}
            />
            <button
                onClick={this.handleFetchFile}
                style={{ padding: "10px", backgroundColor: "blue", color: "white", border: "none" }}
            >
                Buscar Arquivo
            </button>

            {this.state.fileData && (
                <div style={{ marginTop: "20px" }}>
                    <h3>Arquivo:</h3>
                    {this.state.fileName.toLowerCase().endsWith(".pdf") ? (
                        <iframe
                            src={this.state.fileData}
                            title="PDF Viewer"
                            style={{ width: "100%", height: "500px", border: "1px solid #ddd" }}
                        />
                    ) : (
                        <img
                            src={this.state.fileData}
                            alt={this.state.fileName}
                            style={{ maxWidth: "100%", maxHeight: "500px", border: "1px solid #ddd" }}
                        />
                    )}
                </div>
            )}
        </div>
    );
  }
}

TesteArquivo.contextType = AuthContext;
export default withRouter(TesteArquivo)